import { render, staticRenderFns } from "./ContainerForm.vue?vue&type=template&id=055b7dae&scoped=true"
import script from "./ContainerForm.vue?vue&type=script&lang=js"
export * from "./ContainerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b7dae",
  null
  
)

export default component.exports